import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { adminGoogleSession } from "@/lib/api";

export default function AdminAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    adminGoogleSession(sid)
      .then(({ session_id }) => {
        sessionStorage.setItem("dh_admin_session", session_id);
        toast.success("Signed in with Google");
      })
      .catch((err) => {
        const detail = err?.response?.data?.detail;
        toast.error(typeof detail === "string" ? detail : "Google sign-in failed. Please try again.");
      })
      .finally(() => navigate("/admin", { replace: true }));
  }, [location.hash, navigate]);

  return <div className="container-x py-32 text-center text-[color:var(--dh-slate)]" data-testid="admin-auth-callback">Signing you in…</div>;
}
